import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { ApprovepopComponent } from '../../grid/approvepop/approvepop.component';
import { HostListener } from '@angular/core';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { TranspaymentinfoComponent } from '../../grid/transpaymentinfo/transpaymentinfo.component';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';
import { AddtranspaymodepopupComponent } from '../../generalpopup/addtranspaymodepopup/addtranspaymodepopup.component';
@Component({
  selector: 'app-addfinalsettlement',
  templateUrl: './addfinalsettlement.component.html',
  styleUrls: ['./addfinalsettlement.component.css']
})
export class AddfinalsettlementComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild('approvebar', { static: false }) approvebar;
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  formname: string = "FinalSettlement";

  //Display
  formmode: string = "Add";
  rtnform: string = "";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  isapprovemode: boolean = false;
  isrejectmode: boolean = false;
  ispaymentmode: boolean = false;

  saveloading: boolean;

  isemploading: boolean=false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  isshowattachment: boolean = false;
  attachmentcount: number = 0;

  isshowapproval: boolean = false;
  iscomments: boolean = false;

  isapprove: boolean = false;
  isreject: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;

  ismanualclose: boolean;

  //Filter
  filterstatus: string = "ALL";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;
  filterrelievetypeid: any = null;
  filterrelievetypename: any = null;

  //Edit Get Values
  finalsettlementColl: any = [];
  finalsettlementid: number = 0
  finalsettlementBO: any = {}

  relievetypeColl: any = [];
  transpaymodeColl: any = [];
  empColl: any = [];
  empBO: any = {}

  checkfeildmsg: any = "";

  finalsettlementform = new FormGroup({
    finalsettlementid: new FormControl(0),
    empid: new FormControl(null, Validators.required),
    transdt: new FormControl(null, Validators.required),
    releasedt: new FormControl(null, Validators.required),
    relievetypeid: new FormControl(null, Validators.required),
    descr: new FormControl(''),
    gravityamount: new FormControl(null, Validators.required),
    pendingamount: new FormControl(null, Validators.required),
    inactive: new FormControl(false),
  });

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.finalsettlementid = params.id
      }

      if (params.rtnform !== undefined) {
        this.rtnform = params.rtnform
      }
    });
    this.fnGetParameterVariable();

    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }
  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filteremployeeid = params.empid
      }

      if (params.empname !== undefined) {
        this.filteremployeename = params.empname
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }

      if (params.fromdate !== undefined) {
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
      if (params.relievetypeid !== undefined) {
        this.filterrelievetypeid = params.relievetypeid
      }

      if (params.relievetypename !== undefined) {
        this.filterrelievetypename = params.relievetypename
      }
      
    })
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.finalsettlementform.reset();
      this.fnInitializeFormGroup();

      if (this.finalsettlementid > 0) {
        this.fngetFinalSettlement();
      }

      this.fngetEmployee();
      this.fngetRelieveType();


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.finalsettlementid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    this.isapprovemode = this.loginService.fnCheckUserRoleAction(this.formname, 'APPROVE')
    this.isrejectmode = this.loginService.fnCheckUserRoleAction(this.formname, 'REJECT')
    this.ispaymentmode = this.loginService.fnCheckUserRoleAction(this.formname, 'PAYMENT')


    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  fnInitializeFormGroup() {
    this.finalsettlementform.setValue({
      finalsettlementid: 0,
      empid: null,
      transdt: new Date(),
      releasedt: new Date(),
      relievetypeid: null,
      descr: '',
      gravityamount:null,
      pendingamount: null,
      inactive: false,

    })
  }

  fngetRelieveType() {
    var data = {
      'relievetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getRelieveType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.relievetypeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetEmployee() {
    this.isemploading=true;   
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          this.isemploading=false;   
          if (res.json().status === 200) {
            this.empColl = res.json().result;
            this.fnChangeEmpLookup();
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.isemploading=false;   
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetFinalSettlement() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'finalsettlementid': this.finalsettlementid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getFinalSettlement(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.finalsettlementColl = res.json().result;
            var editdata = this.finalsettlementColl[0];
            this.finalsettlementBO = editdata;
            console.log(this.finalsettlementBO)
            this.fnEditMode(editdata);
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }


  fnChangeEmpLookup() {
    var empid = 0;

    empid = this.finalsettlementform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {
        if (abo.empid === empid) {
          this.empBO = abo;
        }
      }

    }
    else {
      this.empBO = {};
    }


  }

  // fnResetValidation() {
  //   if (this.loginService.fnCheckFornControlNotfound(this.finalsettlementform.get('enddt'))) {
  //     this.finalsettlementform.controls['enddt'].setErrors(null);
  //   }
  //   if (this.loginService.fnCheckFornControlNotfound(this.finalsettlementform.get('inactive'))) {
  //     this.finalsettlementform.controls['inactive'].setErrors(null);
  //   }
  // }
  // fnSetValidation() {
  //   let _ischeck = false;
  //   if (this.loginService.fnCompareDateValidation(this.finalsettlementform.get('enddt').value, this.finalsettlementform.get('startdt').value)) {
  //     this.finalsettlementform.controls['enddt'].setErrors({ 'notfound': true });
  //     _ischeck = true;
  //   }

  //   return _ischeck;
  // }


  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;

      // this.fnResetValidation()
      //Validate
      if (this.finalsettlementform.valid) {

        // if (this.fnSetValidation()) {
        //   return;
        // }

        //Check
        var data = {
          'finalsettlementid': this.finalsettlementid,
          'empid': this.finalsettlementform.get('empid').value,
          'transdt': this.fnFormatDatetime(this.finalsettlementform.get('transdt').value),
          'releasedt': this.fnFormatDatetime(this.finalsettlementform.get('releasedt').value),
          'relievetypeid': this.finalsettlementform.get('relievetypeid').value,
          'descr': this.finalsettlementform.get('descr').value,
          'gravityamount': this.finalsettlementform.get('gravityamount').value,
          'pendingamount': this.finalsettlementform.get('pendingamount').value,
          'inactive': this.finalsettlementform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        if (this.finalsettlementform.get('finalsettlementid').value > 0) {
          //Update 
          this.fnSetFinalSettlement(data);
        }
        else {
          //Insert 
          this.fnInsertFinalSettlement(data);
        }


      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }




  //Insert
  fnInsertFinalSettlement(data) {

    this.appService.fnInsertFinalSettlement(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag()
            this.toastr.success('', "The new FinalSettlement has been added successfully.");
            this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));

            var _result = res.json().result;
            if (_result.length > 0) {
              this.fnEditFormEdit(_result[0].finalsettlementid);
            }

          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetFinalSettlement(data) {

    this.appService.fnSetFinalSettlement(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag()
            this.toastr.success('', "The FinalSettlement has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.finalsettlementid, this.fngetDescriptionRefno(data));
            this.fnEditFormEdit(this.finalsettlementid);

          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }



  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }


  fnAddPaymentInfo() {

    const modalRef = this.productFindService.open(TranspaymentinfoComponent, { size: <any>'l' });
    modalRef.componentInstance.trid = this.finalsettlementid;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.transdate = this.finalsettlementBO.transdate;
    modalRef.componentInstance.transpaymodeid = this.finalsettlementBO.transpaymodeid;
    modalRef.componentInstance.refno = this.finalsettlementBO.payrefno;
    modalRef.componentInstance.paiddt = this.fnConvertDatetime(this.fnFormatDatetime(this.finalsettlementBO.paiddt));
    modalRef.componentInstance.paymentinfo = this.finalsettlementBO.paymentinfo;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === "DONE") {
        this.fngetFinalSettlement();
      }

    });

  }


  fnEditFormEdit(id) {

    this.finalsettlementid = id;
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;


    let queryParams = {
      'id': id,
      'status': this.filterstatus,
      'empid': this.filteremployeeid,
      'empname': this.filteremployeename,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'relievetypeid': this.filterrelievetypeid,
      'relievetypename': this.filterrelievetypename,
      
    }



    this.router.navigate([], { relativeTo: this.route, queryParams: queryParams }).then(() => {
      this.ngOnInit();
    });
  }
  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;

      if (this.rtnform !== '') {
        this.router.navigate(['/' + this.rtnform]);
      } else {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            'status': this.filterstatus,
            'empid': this.filteremployeeid,
            'empname': this.filteremployeename,
            'fromdate': this.fnFormatDatetime(this.filterfromdate),
            'relievetypeid': this.filterrelievetypeid,
            'relievetypename': this.filterrelievetypename,
          }
        }

        this.router.navigate(['/FinalSettlement'], navigationExtras);
      }


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    deptBO.transdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.transdt));
    deptBO.releasedt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.releasedt));
  

    this.finalsettlementform.setValue({
      finalsettlementid: deptBO.finalsettlementid,
      empid: deptBO.empid,
      transdt: deptBO.transdt,
      releasedt: deptBO.releasedt,
      relievetypeid: deptBO.relievetypeid,
      descr: deptBO.descr,
      gravityamount: deptBO.gravityamount,
      pendingamount: deptBO.pendingamount,
      inactive: deptBO.inactive

    });

    this.formmode = "Edit";

    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

    this.fnVisibilityApproveStatus();

    this.fnChangeEmpLookup();

    this.fnGetAttachmentCount()
  }
  //Comment
  fnCommentsBtnClick() {

    this.iscomments = true;
  }

  //Approvals
  fnApproveBtnClick(type) {


    this.approvebar.formtype = type;
    this.approvebar.fnInitializeFormGroup();
    this.approvebar.fnGetApproveForms();

    this.isshowapproval = !this.isshowapproval

  }

  fnCloseApproveBtnClick(data) {
    this.isshowapproval = !this.isshowapproval

    if (data === 'DONE') {
      this.fngetFinalSettlement();
    }

  }

  fnVisibilityApproveStatus() {

    this.isapprove = false;
    this.isreject = false;

    if (this.finalsettlementBO.approvedstatus !== '') {
      if (this.finalsettlementBO.approvedstatus === 'Approve') {
        this.isreject = true;
      }
      else if (this.finalsettlementBO.approvedstatus === 'Reject') {
        this.isapprove = true;
      }
    }
    else {
      this.isapprove = true;
      this.isreject = true;
    }

  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }


  //#Attachment
  fnAttachmentBtnClick() {

    const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.finalsettlementid;
    modalRef.componentInstance.formmode = "EDIT";
    modalRef.componentInstance.fnGetAttachment();


    modalRef.result.then(() => {
      this.fnGetAttachmentCount()
    }, () => {
      this.fnGetAttachmentCount()
    })


    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === 'DONE') {
        this.fngetFinalSettlement();
      }
      this.fnGetAttachmentCount()
    });

  }


  fnAttachmentSave(tid) {



  }



  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }


  //Approvals POP
  fnShowApprovalPop(stauts) {

    const modalRef = this.productFindService.open(ApprovepopComponent, { size: <any>'l' });
    modalRef.componentInstance.formmode = stauts;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.formid = this.finalsettlementid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry === 'DONE') {
        this.fngetFinalSettlement();
      }


    });
  }




  //Attachment
  fnGetAttachmentCount() {
    if (this.finalsettlementid > 0) {
      var data = {
        'trxid': this.finalsettlementid,
        'trxtype': this.formname,
      }


      this.appService.fngetAttachmentCountDetails(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            var result = res.json().result;
            if (result.length > 0) {
              this.attachmentcount = result[0].attachmentcount
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
    }

  }


  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }
  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.isaddmode || this.iseditmode) {
      return false;
    }
    else {
      return true;
    }
  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  fnResetSaveFlag() {
    this.submitted = false;
    this.successfully = false;
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}